module.exports = __webpack_public_path__ + "img/gk.4453af41.svg";